import { useState } from "react";
import { Share2, Check } from "lucide-react";
import { toast } from "sonner";
import { BACKEND_URL } from "../lib/api";

export const ShareButton = ({ path, title, text, testId = "share-button", className = "" }) => {
  const [copied, setCopied] = useState(false);
  const url = `${BACKEND_URL}/api/share${path}`;

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
        return;
      } catch (err) {
        if (err?.name === "AbortError") return;
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copiato! Incollalo su WhatsApp: apparirà con foto e nome.");
      setTimeout(() => setCopied(false), 2500);
    } catch {
      toast.error("Non riesco a copiare il link: " + url);
    }
  };

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={share}
      className={`flex items-center gap-2 rounded-full border border-[#CFC0B2] px-5 py-2.5 text-sm font-semibold text-[#5C534B] transition-all duration-300 hover:border-[#B85328] hover:text-[#B85328] ${className}`}
    >
      {copied ? <Check size={15} /> : <Share2 size={15} />}
      {copied ? "Copiato" : "Condividi"}
    </button>
  );
};
